import React from 'react';
import SEO from "../../common/SEO";
import Layout from "../../common/Layout";

const Aspire = () => {

    function AspireEmbed() {
        return (
          <div style={{ position: 'relative', paddingTop: 'max(60%,326px)', height: 0, width: '100%' }}>
            <iframe
              allow="clipboard-write"
              sandbox="allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-modals allow-popups-to-escape-sandbox allow-forms"
              allowFullScreen={true}
              style={{ position: 'absolute', border: 'none', width: '100%', height: '100%', left: 0, right: 0, top: 0, bottom: 0 }}
              src="https://e.issuu.com/embed.html?d=aspire_2024-final4&u=i94westchamber"
            />
          </div>
        );
      }


    return (
        <>
            <SEO title="Aspire Guide" />
            <Layout>
                <div className="main-content">
                    <AspireEmbed/>
                    <div class="container pt--20">
                    <p>We self-publish our annual publication which includes print distribution to our membership and within our chamber communities. We also have a significant digital and social media distribution network. To advertise in our annual publication <a href="mailTo:abby@i94westchamber.org" style={{'color':'lightblue'}}>click here</a>.
        </p>
        </div>
                </div>
            </Layout>
        </>
    )
}
export default Aspire;